import * as RadixThemes from '@radix-ui/themes'
import * as React from 'react'

import { MenuNamespaceProvider } from '../menu-namespace'

import styles from './context-menu-target.module.css'

type Props = {
  children: React.ReactNode
  /**
   * Menu body to open on right-click. Written against `useMenu()` so the same
   * component can also be rendered inside a `DropdownMenu.Content`.
   */
  menu: React.ReactNode
  /** Renders `children` untouched, leaving the native browser menu in place. */
  disabled?: boolean
  onOpenChange?: (open: boolean) => void
}

/**
 * Attaches a right-click menu to a row without changing its markup or
 * layout. Mouse right-click only: Radix's Trigger also opens on a
 * touch/pen long-press by default, so that path is preempted via
 * `onPointerDown` — right-click is a mouse-only interaction here.
 */
const ContextMenuTarget = ({
  children,
  menu,
  disabled,
  onOpenChange,
}: Props): React.ReactNode => {
  if (disabled) return children

  return (
    <RadixThemes.ContextMenu.Root onOpenChange={onOpenChange}>
      <RadixThemes.ContextMenu.Trigger
        onPointerDown={event => {
          if (event.pointerType !== 'mouse') event.preventDefault()
        }}
      >
        <div className={styles.trigger}>{children}</div>
      </RadixThemes.ContextMenu.Trigger>
      <RadixThemes.ContextMenu.Content>
        <MenuNamespaceProvider value={RadixThemes.ContextMenu}>
          {menu}
        </MenuNamespaceProvider>
      </RadixThemes.ContextMenu.Content>
    </RadixThemes.ContextMenu.Root>
  )
}

export default ContextMenuTarget
